export const TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const TOKEN_EXPIRE_AT_KEY = 'token_expire_at';
export const TOKEN_EXPIRE_IN_KEY = 'token_expire_in';
export const SSO_CODE = 'sso_code';
export const CODE_VERIFIER = 'code_verifier';

export default {
    TOKEN_KEY,
    REFRESH_TOKEN_KEY,
    TOKEN_EXPIRE_IN_KEY,
    TOKEN_EXPIRE_AT_KEY,
    SSO_CODE,
    CODE_VERIFIER,
};
